import * as React from "react";
import styled, { useTheme } from "styled-components";
import { InProgressAnimation } from "common/Icons/Icons";

const AnimatedInProgressIcon = (props: any) => {
  const theme = useTheme();
  return <StyledIcon {...props} $isDarkMode={theme.isDarkMode} />;
};
export default AnimatedInProgressIcon;

const StyledIcon = styled(InProgressAnimation)<{ $isDarkMode?: boolean }>`
  #frame {
    fill: ${(p) => (p.$isDarkMode ? p.theme.colors.white : "#0D144E")};
  }
  #eAfKVS5CPcG6,
  #eAfKVS5CPcG7,
  #eAfKVS5CPcG8,
  #eAfKVS5CPcG9 {
    fill: ${(p) => p.theme.colors.primaryBlue};
  }
  #eAfKVS5CPcG3_tr {
    animation: eAfKVS5CPcG3_tr__tr 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG3_tr__tr {
    0% {
      transform: translate(58.499997px, 58.314486px) rotate(0deg);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    4.333333% {
      transform: translate(58.499997px, 58.314486px) rotate(7.952005deg);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    14.333333% {
      transform: translate(58.499997px, 58.314486px) rotate(-32.353691deg);
      animation-timing-function: cubic-bezier(0.42, 0, 1, 1);
    }
    35.333333% {
      transform: translate(58.499997px, 58.314486px) rotate(193.271867deg);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    42% {
      transform: translate(58.499997px, 58.314486px) rotate(172.29171deg);
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    46% {
      transform: translate(58.499997px, 58.314486px) rotate(181.029699deg);
    }
    100% {
      transform: translate(58.499997px, 58.314486px) rotate(181.029699deg);
    }
  }
  #eAfKVS5CPcG6 {
    animation-name: eAfKVS5CPcG6__m, eAfKVS5CPcG6_c_o;
    animation-duration: 3529.4117647058824ms;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
    animation-direction: normal;
    animation-iteration-count: infinite;
  }
  @keyframes eAfKVS5CPcG6__m {
    0% {
      d: path(
        "M58.5,73.18738C65.10719,73.12532,70.2543,81.8345,72.94445,86.54658C75.63461,91.25866,74.83144,95.49744,70.94106,95.49744C68.35004,95.49744,64.20302,95.49744,58.5,95.49744C58.49434,95.49744,58.48868,95.49744,58.48302,95.49744C52.78,95.49744,48.63298,95.49744,46.04196,95.49744C42.15158,95.49744,41.34841,91.25866,44.03857,86.54658C46.72873,81.8345,51.87584,73.12532,58.48302,73.18738"
      );
    }
    4.333333% {
      d: path(
        "M58.5,73.18738C65.10719,73.12532,70.2543,81.8345,72.94445,86.54658C75.63461,91.25866,74.83144,95.49744,70.94106,95.49744C68.35004,95.49744,64.20302,95.49744,58.5,95.49744C58.49434,95.49744,58.48868,95.49744,58.48302,95.49744C52.78,95.49744,48.63298,95.49744,46.04196,95.49744C42.15158,95.49744,41.34841,91.25866,44.03857,86.54658C46.72873,81.8345,51.87584,73.12532,58.48302,73.18738"
      );
    }
    14.333333% {
      d: path(
        "M58.024697,69.955023C64.925363,71.303698,70.2543,81.8345,72.94445,86.54658C75.63461,91.25866,74.83144,95.49744,70.94106,95.49744C68.35004,95.49744,64.20302,95.49744,58.5,95.49744C58.49434,95.49744,58.48868,95.49744,58.48302,95.49744C52.78,95.49744,48.63298,95.49744,46.04196,95.49744C42.15158,95.49744,41.34841,91.25866,44.03857,86.54658C46.72873,81.8345,51.418967,71.368071,58.024697,69.955023"
      );
    }
    24.333333% {
      d: path(
        "M60.159898,69.859313C67.060564,71.207988,72.010688,81.080854,73.713854,86.543053C75.41702,92.005252,74.83144,95.49744,70.94106,95.49744C68.35004,95.49744,64.20302,95.49744,58.5,95.49744C58.49434,95.49744,58.48868,95.49744,58.48302,95.49744C52.78,95.49744,48.63298,95.49744,46.04196,95.49744C42.15158,95.49744,41.34841,91.25866,44.03857,86.54658C46.72873,81.8345,53.554168,71.272361,60.159898,69.859313"
      );
    }
    33% {
      d: path(
        "M58.726634,70.212629C64.555548,70.250628,72.010688,81.080854,73.713854,86.543053C75.41702,92.005252,72.845429,95.572316,68.955049,95.572316C66.364029,95.572316,64.20302,95.49744,58.5,95.49744C58.49434,95.49744,58.48868,95.49744,58.48302,95.49744C52.78,95.49744,50.778533,95.562941,48.187513,95.562941C44.297133,95.562941,41.963782,90.375496,43.899035,86.412309C45.834288,82.449122,52.108104,70.431091,58.726634,70.212629"
      );
    }
    39.666667% {
      d: path(
        "M58.726634,70.212629C64.555548,70.250628,70.183733,78.241817,68.475119,82.856079C66.766505,87.470341,65.204439,90.017581,62.008177,93.203551C59.697239,94.940321,57.273513,95.483816,51.570493,95.483816C51.564833,95.483816,51.576148,95.483802,51.570488,95.483802C49.718282,95.318842,48.074116,94.63795,46.853022,93.864633C42.967759,91.176033,43.477409,86.418503,45.412662,82.455316C47.347915,78.492129,52.108104,70.431091,58.726634,70.212629"
      );
    }
    47.333333% {
      d: path(
        "M58.726634,70.212629C64.555548,70.250628,70.183733,78.241817,68.475119,82.856079C66.766505,87.470341,65.18094,88.78243,61.841662,89.95717C58.1741,90.658838,56.269398,91.703785,50.566378,91.703785C50.560718,91.703785,50.62486,91.702835,50.6192,91.702835C48.766994,91.537875,47.448732,91.011121,46.227638,90.237804C43.77094,88.360857,43.477409,86.418503,45.412662,82.455316C47.347915,78.492129,52.108104,70.431091,58.726634,70.212629"
      );
    }
    56.666667% {
      d: path(
        "M58.726634,70.212629C64.555548,70.250628,69.322641,80.157442,68.475119,82.856079C67.627597,85.554716,64.015555,86.189743,60.907334,86.850566C57.160243,87.377725,56.193794,87.497599,50.490774,87.497599C50.485114,87.497599,50.496436,87.497602,50.490776,87.497602C48.63857,87.332642,47.653536,86.708982,46.432442,85.935665C45.460838,85.135698,44.761591,84.17755,45.412662,82.455316C46.063733,80.733082,52.108104,70.431091,58.726634,70.212629"
      );
    }
    62.333333% {
      d: path(
        "M58.726634,70.212629C64.555548,70.250628,67.83651,75.465445,66.988988,78.164082C66.141466,80.862719,62.884953,82.022478,59.649264,82.19944C57.318923,82.418917,57.275487,82.242104,55.66611,82.271012C55.66045,82.271012,55.671772,82.271035,55.666112,82.271035C54.839334,82.216167,53.557738,81.99365,52.725659,81.703893C51.104519,80.833236,50.408251,79.96626,49.844643,78.472228C49.281035,76.978196,52.108104,70.431091,58.726634,70.212629"
      );
    }
    100% {
      d: path(
        "M58.726634,70.212629C64.555548,70.250628,67.83651,75.465445,66.988988,78.164082C66.141466,80.862719,62.884953,82.022478,59.649264,82.19944C57.318923,82.418917,57.275487,82.242104,55.66611,82.271012C55.66045,82.271012,55.671772,82.271035,55.666112,82.271035C54.839334,82.216167,53.557738,81.99365,52.725659,81.703893C51.104519,80.833236,50.408251,79.96626,49.844643,78.472228C49.281035,76.978196,52.108104,70.431091,58.726634,70.212629"
      );
    }
  }
  @keyframes eAfKVS5CPcG6_c_o {
    0% {
      opacity: 1;
    }
    66.333333% {
      opacity: 1;
    }
    71.666667% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #eAfKVS5CPcG6_ts {
    animation: eAfKVS5CPcG6_ts__ts 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG6_ts__ts {
    0% {
      transform: translate(58.364978px, 70.379458px) scale(1, 1);
    }
    62.333333% {
      transform: translate(58.364978px, 70.379458px) scale(1, 1);
    }
    71.666667% {
      transform: translate(58.364978px, 70.379458px) scale(0.401583, 0.401583);
    }
    100% {
      transform: translate(58.364978px, 70.379458px) scale(0.401583, 0.401583);
    }
  }
  #eAfKVS5CPcG7_to {
    animation: eAfKVS5CPcG7_to__to 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG7_to__to {
    0% {
      offset-distance: 0%;
    }
    36.333333% {
      offset-distance: 0%;
      animation-timing-function: cubic-bezier(0.42, 0, 0.58, 1);
    }
    46% {
      offset-distance: 26.296341%;
      animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    }
    62.333333% {
      offset-distance: 100%;
    }
    100% {
      offset-distance: 100%;
    }
  }
  #eAfKVS5CPcG7 {
    animation: eAfKVS5CPcG7_c_o 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG7_c_o {
    0% {
      opacity: 1;
    }
    62.333333% {
      opacity: 1;
    }
    63% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #eAfKVS5CPcG8_to {
    animation: eAfKVS5CPcG8_to__to 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG8_to__to {
    0% {
      transform: translate(58.651318px, 82.098903px);
    }
    39.666667% {
      transform: translate(58.651318px, 78.098903px);
    }
    66.333333% {
      transform: translate(58.237991px, 55.102616px);
    }
    100% {
      transform: translate(58.237991px, 55.102616px);
    }
  }
  #eAfKVS5CPcG8_ts {
    animation: eAfKVS5CPcG8_ts__ts 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG8_ts__ts {
    0% {
      transform: scale(0.457106, 0.457106);
    }
    35% {
      transform: scale(0.457106, 0.457106);
    }
    39.666667% {
      transform: scale(0.983171, 0.983171);
    }
    66.333333% {
      transform: scale(0.983171, 0.983171);
    }
    76% {
      transform: scale(0.983171, 0.307503);
    }
    100% {
      transform: scale(0.983171, 0.307503);
    }
  }
  #eAfKVS5CPcG8 {
    animation: eAfKVS5CPcG8_c_o 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG8_c_o {
    0% {
      opacity: 1;
    }
    71.666667% {
      opacity: 1;
      animation-timing-function: cubic-bezier(0, 0, 0.58, 1);
    }
    80% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
  #eAfKVS5CPcG9_ts {
    animation: eAfKVS5CPcG9_ts__ts 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG9_ts__ts {
    0% {
      transform: translate(58.835476px, 86.761886px) scale(0.012915, 0.012915);
    }
    62.666667% {
      transform: translate(58.835476px, 86.761886px) scale(0.012915, 0.012915);
    }
    80% {
      transform: translate(58.835476px, 86.761886px) scale(1, 1);
    }
    100% {
      transform: translate(58.835476px, 86.761886px) scale(1, 1);
    }
  }
  #eAfKVS5CPcG9 {
    animation: eAfKVS5CPcG9_c_o 3529.4117647058824ms linear infinite normal
      forwards;
  }
  @keyframes eAfKVS5CPcG9_c_o {
    0% {
      opacity: 0;
    }
    62% {
      opacity: 0;
    }
    62.666667% {
      opacity: 1;
    }
    100% {
      opacity: 1;
    }
  }
`;
